import {
  CreditCardPayment as ApacCreditCardPayment,
  type CreditCardPaymentProps,
} from "@apac/checkout";
import { useBooleanFlag } from "@apac/feature-flags";
import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  ENABLE_PAYMENT_METHODS_SUBTITLE,
  FeatureFlagNames,
} from "@hsbc/utilities";
import styles from "./styles.module.scss";

export const CreditCardPayment = (props: CreditCardPaymentProps) => {
  const { t } = useI18nContext();
  const [, cn] = useModuleBEM(styles, "CreditCardPayment");

  const showDisabled3dsNotice =
    useBooleanFlag(FeatureFlagNames.SHOW_DISABLED_3DS_NOTICE) ?? false;

  return (
    <ApacCreditCardPayment
      {...props}
      yearDigit="two"
      description={
        ENABLE_PAYMENT_METHODS_SUBTITLE ? (
          <span className={cn("subheader")}>
            {showDisabled3dsNotice && t("paymentMethods.disabled_3ds_notice")}
            {t("paymentMethods.subtitle")}
          </span>
        ) : undefined
      }
    />
  );
};
